module.exports = __webpack_public_path__ + "static/img/bg_5.794af278.png";